import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";
import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

productCardStyles.gridContainer = mergeToNew(productCardStyles.gridContainer, {
    gap: 0,
    css: css`
        padding: 15px 20px;
        min-width: 320px; /* prevent overlap with second column */
        border: 1px solid ${getColor("common.border")};
        border-radius: 12px;
        margin-left: -9px;
        margin-right: -9px;
    `,
});

productCardStyles.searchScoreDataGridItem = mergeToNew(productCardStyles.searchScoreDataGridItem, {
    css: css`
        padding: 0 !important;
    `,
});

productCardStyles.rightColumnGridItem = mergeToNew(productCardStyles.rightColumnGridItem, {
    css: css`
        > [class^="GridWrapper"] {
            > [class^="GridOffset"] {
                > [class^="GridItemStyle"] {
                    &:nth-of-type(2) {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    null,
                                    css`
                                        justify-content: right;
                                    `,
                                ],
                                "min",
                            )}
                        > div {
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        null,
                                        null,
                                        css`
                                            padding-left: 0;
                                            padding-right: 0;
                                            section {
                                                > div {
                                                    margin-top: 0;
                                                }
                                            }
                                        `,
                                    ],
                                    "min",
                                )}
                        }
                    }
                }
            }
        }
    `,
});
